import sponsor from '@/pages/sponsor'

export default [
  {
    path: "/sponsorList",
    name: "sponsorList",
    component: sponsor,
  }
];
